import loadConfiguration3 from "./loadConfiguration3";
import loadPublicConfiguration3 from "./loadPublicConfiguration3";

const app3 = {
  loadConfiguration3,
  loadPublicConfiguration3,
};

export default app3;
